var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5479 29.4888C20.6941 29.742 20.9044 29.9523 21.1577 30.0986C21.411 30.2448 21.6983 30.3218 21.9907 30.3218C22.2832 30.3218 22.5705 30.2448 22.8237 30.0986C23.077 29.9523 23.2873 29.742 23.4336 29.4888",
    stroke: "#1A1A1A",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7118 24.7618C14.603 24.8811 14.5311 25.0294 14.5051 25.1888C14.479 25.3481 14.4998 25.5116 14.5649 25.6594C14.6301 25.8071 14.7367 25.9327 14.872 26.021C15.0072 26.1092 15.1651 26.1563 15.3266 26.1564H28.6556C28.8171 26.1564 28.9751 26.1096 29.1104 26.0215C29.2457 25.9334 29.3525 25.8079 29.4178 25.6603C29.4831 25.5126 29.5041 25.3492 29.4782 25.1898C29.4524 25.0305 29.3808 24.8821 29.2721 24.7627C28.1641 23.6205 26.9895 22.4067 26.9895 18.6588C26.9895 17.3331 26.4629 16.0618 25.5255 15.1244C24.5881 14.187 23.3168 13.6604 21.9911 13.6604C20.6655 13.6604 19.3941 14.187 18.4567 15.1244C17.5193 16.0618 16.9927 17.3331 16.9927 18.6588C16.9927 22.4067 15.8173 23.6205 14.7118 24.7618Z",
    stroke: "#1A1A1A",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9839 11.9989C27.9839 9.78996 29.7746 7.99927 31.9835 7.99927V7.99927C34.1925 7.99927 35.9832 9.78996 35.9832 11.9989V11.9989C35.9832 14.2078 34.1925 15.9985 31.9835 15.9985V15.9985C29.7746 15.9985 27.9839 14.2078 27.9839 11.9989V11.9989Z",
    fill: "#EF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotif);
export default __webpack_public_path__ + "static/media/notif.fee4f340d07dbf4fcb92a7a4dc81e7a7.svg";
export { ForwardRef as ReactComponent };